export default [

     {
          path: '/formula-variable',
          name: 'FormulaVariable',
          component: () => import("@/modules/kpi/views/Page/FormulaVariable/FormulaVariable.vue"),
           meta: {
               title: 'FormulaVariable',
          },
     }
];